import React, { useState, useEffect } from "react";
import { setSimulateurObject } from "../../../actions/simulateur.action.js";
import { useDispatch } from "react-redux";
import { styles } from "../../../stylesheets/simulateurs.css.js";
import "../../../stylesheets/simulateursBis.css";
import ButtonYesno from "../../../components/buttons/button.yesno.js";
import TextfieldNumber from "../../../components/textfields/textfield.number.js";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle.js";
import { ToolTipPerso } from "../../../components/selects/tooltip_perso.js";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques.js";
import SelectCommon from "../../../components/selects/select.common";
import { useSnackbar } from "notistack";
import Simulateur_118 from "../simulateur.118/simulateur.118.js";

// Valeur économique de l'usufruit et de la nue-propriété
// simulateur id 113

function Simulateur_113(props) {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const [travaux_entretient_annuel, setTravauxEntretient] = useState(0);
  const [taxe_fonciere, setTaxeFonciere] = useState(0);
  const [taxe_logement_vacant, setTaxeLogementVacant] = useState(0);
  const [fraction_fond_travaux_charges, setFractionFondTravaux] = useState(0);
  const [valeur_locative_brute, setValeurLocativeBrute] = useState(0);
  const [prix_vente_immeuble, setPrixVenteImmeuble] = useState(0);

  const [type_usufruit, setTypeUsufruit] = useState(0); // 0 = viager, 1 = à durée fixe
  const [duree_usufruit, setDureeUsufruit] = useState(0);

  const [usufruitier_successif, setUsufruitierSuccessif] = useState(0);
  const [esperance_vie_usufruitier, setEsperanceVieUsufruitier] = useState(0);
  const [esperance_vie_usufruit_actuel, setEsperanceVieUsufruitierActuel] = useState(0);
  const [esperance_vie_usufruit_successif, setEsperanceVieUsufruitierSuccessif] = useState(0);
  const [simu118, setSimu118] = useState(null);
  const [dataEsperanceVie, setDataEsperanceVie] = useState({});
  const [dependances, setDependancesState] = useState([]);


  useEffect(() => {
  if (parseInt(type_usufruit) === 1) {
    setDataEsperanceVie({});
    setEsperanceVieUsufruitier(0);
    setEsperanceVieUsufruitierActuel(0);
    setEsperanceVieUsufruitierSuccessif(0);
  }
  if (parseInt(type_usufruit) === 0) {
    setDureeUsufruit(0);
  }
}, [type_usufruit]);


  const handleChange = async (setter, value, key) => {
    if (
      setter === setPrixVenteImmeuble ||
      setter === setValeurLocativeBrute ||
      setter === setEsperanceVieUsufruitier ||
      setter === setEsperanceVieUsufruitierActuel ||
      setter === setEsperanceVieUsufruitierSuccessif ||
      setter === setTravauxEntretient ||
      setter === setTaxeFonciere ||
      setter === setTaxeLogementVacant ||
      setter === setFractionFondTravaux ||
      setter === setDureeUsufruit
    ) {
      if (parseInt(value) < 0) {
        enqueueSnackbar("La valeur ne peut pas être négative.", { variant: "error" });
        return;
      }
    }

    if (setter === setDataEsperanceVie) {
      setDataEsperanceVie((prev) => ({
        ...prev,
        [key]: value,
      }));
    } else {
      setter(value);
    }
  };

  const handleChangeRemarque = async (value) => {
    localStorage.setItem("remarque", value);
  };
  
  useEffect(() => {
    if (!props.isParent) return;

    let object = {
      simulateurid: props.simulateur.id,
      inputs: {
        travaux_entretient_annuel: parseInt(travaux_entretient_annuel),
        taxe_fonciere: parseInt(taxe_fonciere),
        taxe_logement_vacant: parseInt(taxe_logement_vacant),
        fraction_fond_travaux_charges: parseInt(fraction_fond_travaux_charges),
        valeur_locative_brute: parseInt(valeur_locative_brute),
        prix_vente_immeuble: parseInt(prix_vente_immeuble),
        type_usufruit: parseInt(type_usufruit),
      },
      dependances: [],
    };

    if (parseInt(type_usufruit) === 0) {
      // VIAGER
      object.inputs = {
        ...object.inputs,
        usufruitier_successif: parseInt(usufruitier_successif),
        esperance_vie_usufruitier: parseInt(esperance_vie_usufruitier),
        esperance_vie_usufruit_actuel: parseInt(esperance_vie_usufruit_actuel),
        esperance_vie_usufruit_successif: parseInt(esperance_vie_usufruit_successif),
        ...dataEsperanceVie,
      };
    } else {
      object.inputs.duree_usufruit = parseInt(duree_usufruit);
      object.inputs.esperance_vie_usufruit_actuel = parseInt(duree_usufruit);
      object.inputs.esperance_vie_usufruitier = parseInt(duree_usufruit);
    }


    dispatch(setSimulateurObject(object));
  }, [
    travaux_entretient_annuel,
    taxe_fonciere,
    taxe_logement_vacant,
    fraction_fond_travaux_charges,
    valeur_locative_brute,
    prix_vente_immeuble,
    type_usufruit,
    duree_usufruit,
    usufruitier_successif,
    esperance_vie_usufruitier,
    esperance_vie_usufruit_actuel,
    esperance_vie_usufruit_successif,
    dataEsperanceVie,
  ]);

  return (
    <div style={styles.container}>
      <div className="cardSimulateur">
          <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id}/>
          <TextfieldRemarques handleChange={handleChangeRemarque}/>
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>
              Valeur vénale de l'immeuble :
              <ToolTipPerso
                title={
                  "Ce prix s'entend hors commission d'agence à la charge du vendeur."
                }
              />
            </div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Indiquer le montant"}
              setter={setPrixVenteImmeuble}
            />
          </div>
          
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>
                Quelle est la valeur locative annuelle brute ?
            </div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Indiquer le montant"}
              setter={setValeurLocativeBrute}
            />
          </div>

          <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>
                  Quel est le montant des travaux d'entretien annuels ?
                  <ToolTipPerso
                    title={
                      "Les gros travaux de l’article 606 du Code civil (soit le clos et le couvert), sont à la charge du nu-propriétaire et ne doivent pas être pris en compte."
                    }
                  />
              </div>
              <TextfieldNumber
                handleChange={handleChange}
                type={"number"}
                placeholder={"Indiquer le montant"}
                setter={setTravauxEntretient}
              />
          </div>

          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>
              S'agit-il d'un lot de copropriété ?
            </div>
            <div>
              <ButtonYesno handleChange={handleChange} setter={setFractionFondTravaux} fieldUndefined={false} defaultValue={0} />
            </div>
          </div>
          {fraction_fond_travaux_charges !== 0 ?
            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>
                Fraction du fonds de travaux afférente aux charges usufructuaires :
              </div>
              <TextfieldNumber
                handleChange={handleChange}
                type={"number"}
                placeholder={"Indiquer le montant"}
                setter={setFractionFondTravaux}
              />
            </div>
            :
            <></>
          }

          <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>
                Montant de la taxe foncière :
              </div>
              <TextfieldNumber
                handleChange={handleChange}
                type={"number"}
                placeholder={"Indiquer le montant"}
                setter={setTaxeFonciere}
              />
          </div>

          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>
                Montant de la taxe sur les logements vacants (le cas échéant) :
                <ToolTipPerso
                  title={
                    "En l’absence de cette taxe, indiquer un montant nul."
                  }
                />
            </div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Indiquer le montant"}
              setter={setTaxeLogementVacant}
              defaultValue={0}
            />
          </div>
          {/* Ancienne version sans intégration du calculateur 118 d'espérance de vie - ATTENTION SI RÉTABLISSEMENT => REMPLACER LES VALEURS DANS OthersMain */}
          {/* <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>
                Y a-t-il un usufruitier successif ?
                <ToolTipPerso
                  title={
                    "Si l’usufruit vendu est commun, il faut retenir la moitié de la valeur et procéder à deux simulations, même si le prix de vente de l’usufruit vendu est commun. " +
                    "Si l’usufruit vendu est indivis, il faut appliquer la quote-part indivise de chaque usufruitier à la valeur de la pleine propriété puis procéder à deux simulations."
                  }
                />
            </div>
            <div>
              <ButtonYesno handleChange={handleChange} setter={setUsufruitierSuccessif} fieldUndefined={false} defaultValue={0} />
            </div>
          </div>
          {parseInt(usufruitier_successif) === 0 ? (
            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>
                Espérance de vie de l'usufruitier (ou durée de l'usufruit choisi) :
                <ToolTipPerso
                  title={
                    <>
                      Lien vers le <a href="https://notaire-langloys.com/categorie/autres/others/118" target="_blank" rel="noopener noreferrer">simulateur</a> pour calculer l'espérance de vie.
                    </>
                  }
                />
              </div>
              <TextfieldNumber
                handleChange={handleChange}
                type={"number"}
                placeholder={"Indiquer l'espérance de vie"}
                setter={setEsperanceVieUsufruitier}
              />
            </div>
        ) : (
          <>
            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>Espérance de vie de l'usufruitier actuel :</div>
              <TextfieldNumber
                handleChange={handleChange}
                type={"number"}
                placeholder={"Indiquer l'espérance de vie"}
                setter={setEsperanceVieUsufruitierActuel}
              />
            </div>
            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>Espérance de vie de l’usufruitier successif :
                <ToolTipPerso
                  title={
                    "Ce champ est pertinent seulement si l’espérance de vie de l’usufruitier successif est supérieur à celui de l’usufruitier actuel."
                  }
                />
              </div>
              <TextfieldNumber
                handleChange={handleChange}
                type={"number"}
                placeholder={"Indiquer l'espérance de vie"}
                setter={setEsperanceVieUsufruitierSuccessif}
              />
            </div>
          </>
        )} */}
      <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            De quel type d’usufruit s’agit-il ?
          </div>
          <SelectCommon
            setter={setTypeUsufruit}
            handleChange={handleChange}
            items={[
              { label: "Viager", value: 0 },
              { label: "À durée fixe", value: 1 },
            ]}
            nameField="label"
            optionValue="value"
            defaultValue={0}
          />

        </div>

        {/* 🆕 Durée usufruit à durée fixe */}
        {parseInt(type_usufruit) === 1 && (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>
              Indiquer la durée de l’usufruit :
              <ToolTipPerso
                title="Si l’acquéreur est une personne morale, l’usufruit ne peut durer plus de trente ans (article 619 du Code Civil)."
              />
            </div>
            <TextfieldNumber
              handleChange={handleChange}
              setter={setDureeUsufruit}
              placeholder={"Indiquer la durée(en années)"}
            />
          </div>
        )}

        {/* Viager → parcours existant */}
        {parseInt(type_usufruit) === 0 && (
          <Simulateur_118
            simulateur={props.simulateur}
            isParent={false}
            callSinceSimu={true}
            dependances={setSimu118}
            handleChange={handleChange}
            setDataEsperanceVie={setDataEsperanceVie}
          />
        )}
      </div>
    </div>
  );
}

export default Simulateur_113;